import React from 'react';
interface CardProps {
  children: ReactNode;
  className?: string;
  padding?: 'none' | 'sm' | 'md' | 'lg';
}
const paddingStyles = {
  none: '',
  sm: 'p-4',
  md: 'p-6',
  lg: 'p-8'
};
export function Card({
  children,
  className = '',
  padding = 'md'
}: CardProps) {
  return <div className={`
        bg-white rounded-lg border border-gray-200 shadow-sm
        ${paddingStyles[padding]}
        ${className}
      `} data-id="element-164">
      {children}
    </div>;
}
interface CardHeaderProps {
  title: string;
  subtitle?: string;
  action?: ReactNode;
}
export function CardHeader({
  title,
  subtitle,
  action
}: CardHeaderProps) {
  return <div className="flex items-start justify-between mb-4" data-id="element-165">
      <div data-id="element-166">
        <h3 className="text-lg font-semibold text-gray-900" data-id="element-167">{title}</h3>
        {subtitle && <p className="text-sm text-gray-500 mt-0.5" data-id="element-168">{subtitle}</p>}
      </div>
      {action && <div data-id="element-169">{action}</div>}
    </div>;
}